// removed by extract-text-webpack-plugin
module.exports = {"setupform-details-form":"_3f64KWsRA _2l0xl0HVf","select":"_8iDamciDC JmRuDZRyu y4wLu1mD3 vUrsJl1Yt _19QZFK_l1 _1NlI_spEh _1EdaqRqa1 _2OFXNnC9U _2WNDOuoxI"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/setupform-details-form/setupform-details-form.css
 ** module id = 2156
 ** module chunks = 0
 **/